<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch4">
<div class="chapterHead">
<p class="centerImage3"><img alt="image" src="images/ch4.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;"><a id="pg-4">You race over to the desk. You pick up the glass Sam was drinking from. And sniff to see if it has a smell. Nothing.</a></p><a id="pg-4">
<p class="para" style="text-indent: 5%;">Sam bursts out laughing. He gives you a devilish grin.</p>
<p class="para" style="text-indent: 5%;">“Water,” Sam says, pointing at the glass. “It’s just water!”</p>
<p class="para" style="text-indent: 5%;">You can’t help laughing, too. You like Sam. He’s funny. But sometimes your best friend can go too far. He’s always playing crazy jokes on you.</p>
<p class="para" style="text-indent: 5%;">Sam gazes around. You’re sure he’s trying to find some other trouble to get into.</p>
<p class="para" style="text-indent: 5%;">“Maybe we should look for my mom,” you suggest.</p>
<p class="para" style="text-indent: 5%;">Anything to keep Sam from getting into more trouble.</p>
<p class="para" style="text-indent: 5%;">His eyes light up. “Great idea!” he cries. “Maybe we can do our own experiments!”</p>
<p class="para" style="text-indent: 5%;">Uh … on second thought …</p>
<p class="para" style="text-indent: 5%;">Maybe you should just sit tight and wait!</p>
</a><p class="extractLetterText" style="text-indent: 5%;"><a id="pg-4"><em class="italic">If you sit down and wait for your mom, turn to</em> </a><span href="#/e9780545841054_ch011" title="Link target outside of Sample"><em class="italic">PAGE 11</em></span>.</p>
<p class="para" style="text-indent: 5%;"><em class="italic">If you look for her, turn to</em> <a href="#/e9780545841054_ch006"><em class="italic">PAGE 6</em></a>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841054_ch004.vue?30fedc95